// src/ui/components/AppSidebar/navConfig.js
// Configuracion de navegacion del sidebar por rol.
// Migrado de AdminMenu (Semantic UI) a iconos @ant-design/icons.
// Reusa las mismas rutas y claves i18n (namespace "common", nav.*).
import React from "react";
import {
  AppstoreOutlined,
  RobotOutlined,
  CheckSquareOutlined,
  NodeIndexOutlined,
  OrderedListOutlined,
  ApartmentOutlined,
  TeamOutlined,
  IdcardOutlined,
  BankOutlined,
  FileTextOutlined,
  DashboardOutlined,
  SettingOutlined,
  ReadOutlined,
  BookOutlined,
} from "@ant-design/icons";
import { NEW_TEACHER_TRAINING } from "../../featureFlags";

// Item de Formacion. Misma pagina para profesor e institucion (cambia la
// audiencia del contenido), por eso se declara una vez y se inyecta en las dos
// ramas del menu. Con el flag apagado no aparece en ninguna.
const trainingItem = (path) =>
  NEW_TEACHER_TRAINING
    ? [{ path, icon: BookOutlined, labelKey: "nav.training" }]
    : [];

// Cada item: { path, icon, labelKey, beta? }
const ROLE_ROUTES = {
  admin: [
    { path: "/portal/users", icon: TeamOutlined, labelKey: "nav.users" },
    { path: "/portal/register", icon: IdcardOutlined, labelKey: "nav.profile" },
    {
      path: "/portal/institution",
      icon: BankOutlined,
      labelKey: "nav.institutions",
    },
  ],
  partner: [
    {
      path: "/portal/partner/register",
      icon: IdcardOutlined,
      labelKey: "nav.infoPartner",
    },
    {
      path: "/portal/partner/institution",
      icon: BankOutlined,
      labelKey: "nav.institutions",
    },
    {
      path: "/portal/partner/facturation",
      icon: FileTextOutlined,
      labelKey: "nav.billing",
    },
    {
      path: "/portal/partner/dashboard",
      icon: DashboardOutlined,
      labelKey: "nav.dashboard",
    },
    {
      path: "/portal/partner/support",
      icon: SettingOutlined,
      labelKey: "nav.support",
    },
  ],
  institution: [
    {
      path: "/portal/inst/profile",
      icon: BankOutlined,
      labelKey: "nav.profile",
    },
    {
      path: "/portal/inst/class",
      icon: ApartmentOutlined,
      labelKey: "nav.classrooms",
    },
    {
      path: "/portal/inst/teachers",
      icon: TeamOutlined,
      labelKey: "nav.teachers",
    },
    {
      path: "/portal/inst/students",
      icon: ReadOutlined,
      labelKey: "nav.students",
    },
    {
      path: "/portal/inst/dashboard",
      icon: DashboardOutlined,
      labelKey: "nav.dashboard",
    },
    {
      path: "/portal/inst/support",
      icon: SettingOutlined,
      labelKey: "nav.support",
    },
    ...trainingItem("/portal/inst/formacion"),
  ],
  teacher: [
    {
      path: "/portal/teacher/salas",
      icon: AppstoreOutlined,
      labelKey: "nav.scenes",
    },
    {
      path: "/portal/teacher/assistant",
      icon: RobotOutlined,
      labelKey: "nav.aiAssistants",
    },
    {
      path: "/portal/teacher/quiz",
      icon: CheckSquareOutlined,
      labelKey: "nav.evaluations",
    },
    {
      path: "/portal/teacher/evaluacion",
      icon: NodeIndexOutlined,
      labelKey: "nav.itineraries",
    },
    {
      path: "/portal/teacher/tareas",
      icon: OrderedListOutlined,
      labelKey: "nav.tasks",
    },
    {
      path: "/portal/teacher/educamaker",
      icon: ApartmentOutlined,
      labelKey: "nav.educamaker",
    },
    ...trainingItem("/portal/teacher/formacion"),
  ],
  student: [
    {
      path: "/portal/student/home",
      icon: AppstoreOutlined,
      labelKey: "nav.content",
    },
  ],
  user: [
    {
      path: "/portal/userfree/salas",
      icon: AppstoreOutlined,
      labelKey: "nav.scenes",
    },
  ],
};

// Ambitos editables (paginas del profesor) para el editor de estilos. FUENTE
// UNICA del nombre de cada pagina: misma clave i18n (common, nav.*) que el menu.
// Asi el nombre del selector del editor y el del menu lateral NUNCA divergen.
export const TEACHER_SCOPES = ROLE_ROUTES.teacher.map(({ path, labelKey }) => ({
  key: path.replace("/portal/", ""), // "teacher/salas"
  path,
  labelKey,
}));

/**
 * Devuelve los items en el formato que espera el Menu de AntD.
 * @param {string} role
 * @param {Function} t - i18n (namespace common)
 * @param {Function} [labelOverride] - (labelKey) => string|undefined; nombre
 *   personalizado del editor de estilos. Si devuelve vacio, usa el i18n.
 */
export function getMenuItems(role, t, labelOverride) {
  const routes = ROLE_ROUTES[role] || [];
  return routes.map(({ path, icon: IconCmp, labelKey, beta }) => {
    const custom = labelOverride && labelOverride(labelKey);
    const name = custom || t(labelKey);
    return {
      key: path,
      icon: <IconCmp />,
      label: beta ? (
        <span>
          {name} <span className="app-sidebar__beta">BETA</span>
        </span>
      ) : (
        name
      ),
    };
  });
}

// Roles que muestran tarjeta de usuario al pie (paridad con AdminMenu actual).
export const ROLES_WITH_USER_CARD = ["institution", "teacher", "user"];
